// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container--Ks2Eo","text-wrapper":"Description-module__text-wrapper--VCuLY","text":"Description-module__text--lg66T"};